
import {
    typeEncashHistoryFilters,
    typeEncashHistoryItem, typeEncashHistoryState
} from 'model/dashboardEncash/dEncashType';
import { paginationMapper, typePagination, typeRequestPagination } from 'model/system/constants';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    dEncashSetDataAC,
    dEncashSetDataSagaAC,
    dEncashSetPaginationAC
} from 'model/dashboardEncash/dEncashActionCreators';
import { errorGenerator } from 'model/system/utils';
import { dashboardLoaderAC } from 'model/system/systemActionCreators';
import { getEncashHistoryList } from 'model/dashboardEncash/dEncashAPI';

// Temp data list mapper
const tempDataMapper = (tempResponseData: any): typeEncashHistoryItem[] => {
    return tempResponseData.map((item: typeEncashHistoryItem) => {
        return (
            {
                id: item.id,
                date: item.date,
                actualTotal: item.actualTotal,
                incassatedAmount: item.incassatedAmount,
                leftAmount: item.leftAmount,
                store: item.store,
                terminalSn: item.terminalSn,
                type: item.type,
                user: item.user
            }
        )
    })

}

// Get data function-generator
function* getData(payload: {
    filters: typeEncashHistoryFilters,
    sortDirection: typeEncashHistoryState['sortDirection'],
    paginationRequest: typeRequestPagination}) {

    let response = yield call(getEncashHistoryList, payload)

    if (response.status === 200) {

        const tempData: typeEncashHistoryItem[] = tempDataMapper(response.data.content)
        const pagination: typePagination = paginationMapper(response.data)

        yield put(dEncashSetPaginationAC(pagination))

        yield put(dEncashSetDataAC(tempData))

    } else {
        yield errorGenerator(response)
    }
}


// ---------------------------------------------------------------------------------------------------------------------
// Set encashment history list saga
export function* dEncashSetDataWorker(actionObject: {
    type: string,
    payload: {
        filters: typeEncashHistoryFilters,
        sortDirection: typeEncashHistoryState['sortDirection']
        paginationRequest: typeRequestPagination
    }
}) {

    yield put(dashboardLoaderAC(true))

    yield getData(actionObject.payload)

    yield put(dashboardLoaderAC(false))

}

export function* dEncashSetDataWatcher() {
    yield takeLatest(dEncashSetDataSagaAC.type, dEncashSetDataWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
